module.exports = __webpack_public_path__ + "static/media/right-arrow.1504834c.png";